$( document ).ready(function() {
    $('.go-to-home-page').on('click',function(){
    /** write related code inside **/
      ToHomePage();
    });
 });
 
 function ToHomePage()
 {
	 window.location.href = "index.html";
 }